<template>
  <div>
    <custom-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :titleObj="titleObj"
    ></custom-header>
    <div class="ad-container">
      <div class="title">合作行业</div>
      <div class="cooperation">
        <div class="item" v-for="(item, index) in cooperation">
          <div class="cooperation-img">
            <img :src="item.img" alt="" />
          </div>
          <div class="cooperation-title">{{ item.title }}</div>
        </div>
      </div>
    </div>

    <div class="ad-container">
      <div class="title">投放广告位</div>
      <div class="putin">
        <div class="item" v-for="(item, index) in putin">
          <div class="putin-content">
            <img :src="item.img" class="putin-img" alt="" />
            <div class="putin-title">
              {{ item.title }}
            </div>
            <img src="../../static/images/ad/b-img-m.png" class="b-img" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="ad-container">
      <div class="title">广告投放内容</div>

      <div class="putcontent">
        <div class="item" v-for="item in putcontent">
          <div class="c-title">
            <img class="c-icon" :src="item.indexIcon" alt="" />
            <span>{{ item.title }}</span>
          </div>
          <div class="desc">{{ item.desc }}</div>
          <div class="c-content" v-for="c in item.contents">
            <div class="cc-title">{{ c.title }}：</div>
            <div class="cc-c">{{ c.content }}</div>
          </div>

          <div class="imgs">
            <img :src="img" alt="" v-for="img in item.imgs" />
            <div class="img-bottom"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="ad-container">
      <div class="title">合作优势</div>

      <div class="advantage">
        <div class="item" v-for="item in advantage">
            <img :src="item.img" class="img"alt="">
            <div class="content">{{ item.content }}</div>
            <img :src="item.indexIcon" class="icon" alt="">
        </div>
      </div>
    </div>

    <Partner :partnerInfo="partner"></Partner>

    <custom-footer :bottom="bottom" :bottomInfo="bottomInfo"></custom-footer>
  </div>
</template>

<script>
import CustomHeader from "@/components/mobile/Header";
import CustomFooter from "@/components/mobile/Footer";
import Partner from "@/components/mobile/Partner";


// 合作行业图标
import cooperation_1 from "@/static/images/ad/cooperation_1.png";
import cooperation_2 from "@/static/images/ad/cooperation_2.png";
import cooperation_3 from "@/static/images/ad/cooperation_3.png";
import cooperation_4 from "@/static/images/ad/cooperation_4.png";

// 投放广告位图标
import puting_1 from "@/static/images/ad/puting_1.png";
import puting_2 from "@/static/images/ad/puting_2.png";
import puting_3 from "@/static/images/ad/puting_3.png";
import puting_4 from "@/static/images/ad/puting_4.png";

// 投放广告内容
import putcontent_1 from "@/static/images/ad/putcontent_1.png";
import putcontent_2 from "@/static/images/ad/putcontent_2.png";
import putcontent_3 from "@/static/images/ad/putcontent_3.png";
import putcontent_4 from "@/static/images/ad/putcontent_4.png";
import putcontent_5 from "@/static/images/ad/putcontent_5.png";
import putcontent_6 from "@/static/images/ad/putcontent_6.png";
import putcontent_7 from "@/static/images/ad/putcontent_7.png";
import putcontent_8 from "@/static/images/ad/putcontent_8.png";

import cooperation_index_1 from "@/static/images/ad/cooperation_index_1.png";
import cooperation_index_2 from "@/static/images/ad/cooperation_index_2.png";
import cooperation_index_3 from "@/static/images/ad/cooperation_index_3.png";
import cooperation_index_4 from "@/static/images/ad/cooperation_index_4.png";

// 合作优势
import advantage_1 from "@/static/images/ad/advantage_1.png";
import advantage_2 from "@/static/images/ad/advantage_2.png";
import advantage_3 from "@/static/images/ad/advantage_3.png";
import advantage_index_1 from "@/static/images/ad/advantage_index_1.png";
import advantage_index_2 from "@/static/images/ad/advantage_index_2.png";
import advantage_index_3 from "@/static/images/ad/advantage_index_3.png";

export default {
  data() {
    return {
      actIndex: 9,
      topStyle: "",
      titleObj: {
        title: "广告投放合作方案",
        desc:
          "广告内容通过各种渠道和方式传播给目标受众，通过广告的商业效应进行变现，获得广告主的广告费用，是当下各线上互联网平台获取增值收益的方式之一，通过长期投放，收获稳定的广告收益。",
      },
      imgList: [],
      bottom: {},
      logo: "",
      bottomInfo: {},
      background: require("../../static/images/ad/bg.png"),
      cooperation: [
        {
          title: "共享充电行业",
          img: cooperation_1,
        },
        {
          title: "停车道闸/充电桩行业",
          img: cooperation_2,
        },
        {
          title: "自动贩卖机/储物柜行业",
          img: cooperation_3,
        },
        {
          title: "零售收银支付行业",
          img: cooperation_4,
        },
      ],
      putin: [
        {
          title: "H5/小程序弹窗",
          img: puting_1,
        },
        {
          title: "缴费页面banner",
          img: puting_2,
        },
        {
          title: "订单确认页banner",
          img: puting_3,
        },
        {
          title: "支付完成页banner",
          img: puting_4,
        },
      ],
      putcontent: [
        {
          imgs: [putcontent_1, putcontent_2],
          indexIcon: cooperation_index_1,
          title: "权益包广告",
          desc:
            "权益包广告包含停车券和充电券数张，用户接触广告后点击进行付费开通，每月扣费获取券。",
          contents: [
            {
              title: "可投放位置",
              content: "缴费页面弹窗，各页面banner，公众号菜单栏",
            },
            {
              title: "结算方式",
              content: "以CPA方式结算，按购买转化数据进行返佣",
            },
          ],
        },
        {
          imgs: [putcontent_3, putcontent_4],
          indexIcon: cooperation_index_2,
          title: "移动积分广告",
          desc:
            "以停车券为广告噱头，通过移动积分兑换停车券，输入手机号快速兑换，广告营销维系移动用户，且消耗移动积分。",
          contents: [
            {
              title: "可投放位置",
              content: "缴费页面弹窗，各页面banner",
            },
            {
              title: "结算方式",
              content: "按CPM方式结算，每千次曝光计费一次",
            },
          ],
        },
        {
          imgs: [putcontent_5, putcontent_6],
          indexIcon: cooperation_index_3,
          title: "充电立减券广告",
          desc:
            "用户通过移动积分/付费，获得充电立减券包，可在微信支付时使用，存放在微信卡券包里。",
          contents: [
            {
              title: "可投放位置",
              content: "缴费页面弹窗，各页面banner",
            },
            {
              title: "结算方式",
              content: "按CPM/CPA方式结算，多种计费方式",
            },
          ],
        },
        {
          imgs: [putcontent_7, putcontent_8],
          indexIcon: cooperation_index_4,
          title: "视听会员广告",
          desc:
            "只要以各大影视平台会员为广告内容，用户通过订阅购买，每月可领取多个平台中的一个会员。",
          contents: [
            {
              title: "可投放位置",
              content: "缴费页面弹窗，各页面banner，公众号菜单栏",
            },
            {
              title: "结算方式",
              content: "以CPA方式结算，按购买转化数据进行返佣",
            },
          ],
        },
      ],
      advantage: [
        {
          img: advantage_1,
          content: "公司拥有大量广告资源，自有广告有长期投放需求，合作长期稳定；",
          indexIcon: advantage_index_1,
        },
        {
          img: advantage_2,
          content:
            "合作灵活多样，并会在广告位规划、 最大获利等多个方面给予专业建议；",
          indexIcon: advantage_index_2,
        },
        {
          img: advantage_3,
          content: "广告投放确定合作后，公司都是预付款方式合作，合作无风险。",
          indexIcon: advantage_index_3,
        },
      ],
      partner:[]
    };
  },
  components: {
    CustomHeader,
    CustomFooter,
    Partner
  },
  mounted() {
    this.Pc_Mobile();
    this.getPageData();
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_AdPutting");
      } else {
        this.$router.push("/AdPutting");
      }
    },
    getPageData() {
      this.$http.post("home/index/m_homeinfo", null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;
        this.topStyle = "background-image:url('" + this.background + "')";
        this.bottomInfo = res.data.contact[0];
        this.partner = res.data.partner;
      });
    },
    // getPageDataM() {
    //   this.$http.post("home/index/m_homeinfo", null, (res) => {
    //     this.Mbottom = res.data.bottom[0];
    //     this.Mlogo = this.Mbottom.logo;
    //     // this.MimgList = res.data.banner;
    //     this.Mabout = res.data.company[0];
    //     this.MbottomInfo = res.data.contact[0];
    //     this.Mpartner = res.data.partner;
    //     this.Mbusiness = res.data.work;
    //     this.Madvantage = res.data.software;
    //     this.Mdevelop = res.data.flow;
    //     this.$nextTick(() => {
    //       this.$refs.MbannerRef.imgSwiper();
    //       // this.$refs.MpartnerRef.imgSwiper();
    //       // this.$refs.MbusinessRef.imgSwiper();
    //       // this.$refs.MdevelopRef.imgSwiper();
    //     });
    //   });
    // },
  },
};
</script>

<style lang="stylus" scoped>
.ad-container{
    background:#fff;
    padding: 45px 12px 0;
    color: #333333;
    .title{
        font-weight: 800;
        font-size: 18px;
        text-align:center;
        margin-bottom: 23px;
    }
    .cooperation{
        display:flex;
        justify-content:space-between;
        align-items:center;
        flex-wrap: wrap;

        .item{
            width: calc(50% - 4px)
            background: #FFFAEB;
            padding:9px 9px 0;
            margin-bottom: 8px;
            .cooperation-img{
                width:100%;
                line-height:1;
                img{
                    width:100%;
                }
            }
            .cooperation-title{
                font-weight: bold;
                font-size: 14px;
                text-align center
                padding:10px 0;
            }
        }
    }

}
.putin{
    display:flex;
    justify-content:space-between;
    flex-wrap: wrap;
    .item{
        padding 7px
        position relative
        width:50%;
        text-align center
        .putin-content{
            position:relative;
        }
        .putin-img{
            position:relative;
            z-index 1
            width:73%
        }
        .putin-title{
            position:relative;
            z-index 1
            font-weight: bold;
            font-size: 8px;
            padding 9px 0
        }
        .b-img{
            position absolute
            bottom 0
            left 0
            width 100%
        }
    }
}
.putcontent{
    .item{
        margin-bottom 23px
        .c-title{
            font-weight: bold;
            font-size: 15px;
            &:after{
                content:'';
                display block
                width: 19px;
                height: 1px;
                background: #FFC000;
                margin-top 14px
            }
            .c-icon{
               width 23px
               height 17px
               margin-right 5px
               margin-top -8px
            }
        }
        .desc{
           margin-top 14px
           font-size 13px
           line-height 1.6
        }
        .c-content{
            display flex
            align-items flex-start
            line-height 1.6
            margin-top 14px
            .cc-title{
                font-weight bold
                font-size 13px
                padding-left 10px
                position relative
                &:before{
                    content ''
                    position absolute
                    left 0
                    top 50%
                    transform: translateY(-50%);
                    width 3px
                    height 3px
                    background #FFC000
                }
            }
            .cc-c{
                flex 1
                font-size 13px
            }
        }
        .imgs{
            position relative
            display flex
            justify-content center
            padding 19px 0 28px
            img{
                position relative
                z-index 1
                width 33%
                margin 0 20px
            }
            .img-bottom{
                position absolute
                bottom 0
                left 0
                width 100%
                height 117px
                background #F7F7F7
            }
        }
    }
}
.advantage{
    .item{
        position relative
        width 100%
        height: 149px;
        background: #FFFFFF;
        border: 1px solid #E1E6F0;
        padding-top 27px
        text-align center
        margin-bottom 9px
        .img{
            width 49px
            height 43px
        }
        .content{
            width 250px
            line-height 1.2
            font-weight bold
            font-size 15px
            margin 20px auto 0
        }
        .icon{
            position absolute
            top 19px
            left 19px
            width 32px
            height 22px
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/AdPutting.vue